export default __webpack_public_path__ + "static/media/brandstof_benzine.c4338c2e.svg";